// TODO: Replace this flat interim fee (TXCC-9673) with the BFF-sourced amount once the
// slate-accessories service returns it (getCustomerAccessories → AccessoriesResponse.shippingCost),
// threaded through use-build-my-deal-vm and use-slate-accessories to the accessory surfaces
// (Selected Accessories modal + order-summary price breakdown).
export const ACCESSORIES_SHIPPING_COST = 140;
